<template>
  <div>
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h4 class="card-title">User Types</h4>
        <span class="badge badge-danger" style="float: right"
          >Banned: {{ this.users.banned }}</span
        >
      </div>
      <div class="card-content">
        <div class="card-body pb-1">
          <div
            class="d-flex justify-content-around align-items-center flex-wrap"
          >
            <!-- <div class="user-analytics">
              <em class="bx bx-briefcase mr-25 align-middle"></em>
              <span class="align-middle text-muted">Staff</span>
              <div class="d-flex">
                <div id="radial-success-chart"></div>
                <h3 class="mt-1 ml-50">{{ staff }}</h3>
              </div>
            </div> -->
            <div class="sessions-analytics">
              <em class="bx bx-user align-middle mr-25"></em>
              <span class="align-middle text-muted">{{$t('Tenants')}}</span>
              <div class="d-flex">
                <div id="radial-warning-chart"></div>
                <h3 class="mt-1 ml-50">{{ users.tenant }}</h3>
              </div>
            </div>
            <div class="bounce-rate-analytics">
              <em class="bx bx-user align-middle mr-25"></em>
              <span class="align-middle text-muted">{{$t('Property Owners')}}</span>
              <div class="d-flex">
                <div id="radial-danger-chart"></div>
                <h3 class="mt-1 ml-50">{{ users.landlord }}</h3>
              </div>
            </div>
          </div>

          <hr />
          <h4 class="card-title">
            Ages
            <span class="badge badge-success" style="float: right"
              >Average: {{ this.ages.average.toFixed(2) }}</span
            >
          </h4>
          <ul class="list-group list-group-flush">
            <span v-for="(age, index) of ages.counts" :key="index">
              <li
                class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                v-for="(count, range) in age"
                :key="range"
              >
                <div class="list-left d-flex">
                  <div class="list-content">
                    <span class="list-title capitalize">{{ range }}</span>
                  </div>
                </div>
                <span class="badge badge-secondary">{{ count }}</span>
              </li>
            </span>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  props: ["users", "ages"],
  data() {
    return {
      staff: 0,
      total: 1,
    };
  },
  methods: {
    initStaffChart(staff) {
      const radialSuccessoptions = {
        chart: {
          height: 40,
          width: 40,
          type: "radialBar",
        },
        grid: {
          show: false,
          padding: {
            left: -30,
            right: -30,
            top: 0,
          },
        },
        series: [(100 * staff) / this.total],
        colors: ["#39DA8A"],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "30%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            gradientToColors: ["#39DA8A"],
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 70, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
      };
      // var radialSuccessChart = new ApexCharts(
      //   document.querySelector("#radial-success-chart"),
      //   radialSuccessoptions
      // );

      // radialSuccessChart.render();
    },
    initTenantsChart(tenants) {
      const radialWarningoptions = {
        chart: {
          height: '43%',
          width: '13%',
          type: "radialBar",
        },
        grid: {
          show: false,
          padding: {
            left: -30,
            right: -30,
            top: 0,
          },
        },
        series: [(100 * tenants) / this.total],
        colors: ["#FDAC41"],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "30%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            gradientToColors: ["#FDAC41"],
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 70, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
      };
      var radialWarningChart = new ApexCharts(
        document.querySelector("#radial-warning-chart"),
        radialWarningoptions
      );

      radialWarningChart.render();
    },
    initLandlordsChart(landlords) {
      const radialDangeroptions = {
        chart: {
          height: '43%',
          width: '13%',
          type: "radialBar",
        },
        grid: {
          show: false,
          padding: {
            left: -30,
            right: -30,
            top: 0,
          },
        },
        series: [(100 * landlords) / this.total],
        colors: ["#FF5B5C"],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "30%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            gradientToColors: ["#FF5B5C"],
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 70, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
      };
      var radialDangerChart = new ApexCharts(
        document.querySelector("#radial-danger-chart"),
        radialDangeroptions
      );

      radialDangerChart.render();
    },
  },
  mounted() {
    const admins = this.users.admin ? this.users.admin : 0;
    const superAdmins = this.users.superadmin ? this.users.superadmin : 0;
    const tenants = this.users.tenant ? this.users.tenant : 0;
    const landlords = this.users.landlord ? this.users.landlord : 0;

    for (const [key, value] of Object.entries(this.users)) {
      this.total += value;
    }

    this.staff = admins + superAdmins;
    this.initStaffChart(this.staff);
    this.initTenantsChart(tenants);
    this.initLandlordsChart(landlords);
  },
};
</script>

